import RadioButton from '@rio-cloud/rio-uikit/RadioButton';
import { FormattedMessage } from 'react-intl';

import { DriverFuelType } from './driverAnalysisReducer';
import useAvailableFuelType from './hooks/useAvailableFuelType';
import useSelectedFuelType from './hooks/useSelectedFuelType';

function DriverFuelTypeToggle() {
    const { selectedFuelType, setSelectedFuelType } = useSelectedFuelType();
    const { availableFuelType } = useAvailableFuelType();

    return (
        <>
            <span className="text-medium padding-bottom-5 text-size-12">
                <FormattedMessage id="select.engineType" />
            </span>
            <div
                className="display-flex justify-content-between column-gap-15 bg-white rounded border-style-solid border-width-1 border-color-light shadow-subtle"
                style={{ padding: '6px' }}
                data-test="driver-fuel-toggle"
            >
                <RadioButton
                    id="all"
                    label={<FormattedMessage id="vehicleFuelType.all" />}
                    onChange={() => setSelectedFuelType(DriverFuelType.ALL)}
                    checked={selectedFuelType === DriverFuelType.ALL}
                    disabled={[
                        DriverFuelType.ELECTRIC,
                        DriverFuelType.FUEL,
                        DriverFuelType.NONE,
                    ].includes(availableFuelType)}
                    inline
                />
                <RadioButton
                    id="electric"
                    label={<FormattedMessage id="vehicleFuelType.electric" />}
                    onChange={() => setSelectedFuelType(DriverFuelType.ELECTRIC)}
                    checked={selectedFuelType === DriverFuelType.ELECTRIC}
                    disabled={[DriverFuelType.FUEL, DriverFuelType.NONE].includes(
                        availableFuelType,
                    )}
                    inline
                />
                <RadioButton
                    id="fuel"
                    label={<FormattedMessage id="vehicleFuelType.fuel" />}
                    onChange={() => setSelectedFuelType(DriverFuelType.FUEL)}
                    checked={selectedFuelType === DriverFuelType.FUEL}
                    disabled={[DriverFuelType.ELECTRIC, DriverFuelType.NONE].includes(
                        availableFuelType,
                    )}
                    inline
                />
            </div>
        </>
    );
}

export default DriverFuelTypeToggle;
